import { z } from 'zod';

import { E_ProfileForm } from '@/ts/enums/E_ProfileForm';

import type { T_Country } from '@/ts/types/T_Country';
import type { T_User } from '@/ts/types/T_User';

export const profileFormSchema = z.object({
  [E_ProfileForm.NICKNAME]: z
    .string()
    .transform(val => val.trim())
    .refine(val => val.length >= 3, 'form.errors.nickname.minLength')
    .refine(val => val.length <= 50, 'form.errors.nickname.maxLength')
    .refine(
      val => /^[a-zA-Z]/.test(val),
      'form.errors.nickname.startsWithLetter'
    ),
  [E_ProfileForm.LANGUAGE]: z
    .string()
    .min(1, 'form.errors.language.required')
    .transform(val => val.trim()),
  [E_ProfileForm.COUNTRY]: z
    .string()
    .min(1, 'form.errors.country.required')
    .transform(val => val.trim()),
  [E_ProfileForm.HIDE_ACTIVITY]: z.boolean()
});

export type T_ProfileFormData = z.infer<typeof profileFormSchema>;

/**
 * Creates form default values from user data
 */
export const createProfileFormDefaultValues = (
  user: T_User | null | undefined,
  countries: T_Country[]
): T_ProfileFormData => ({
  [E_ProfileForm.NICKNAME]: user?.nickname || '',
  [E_ProfileForm.LANGUAGE]: user?.language || 'en',
  [E_ProfileForm.COUNTRY]:
    user?.country || (countries.length > 0 ? countries[0].alpha2Code : ''),
  [E_ProfileForm.HIDE_ACTIVITY]: user?.hideActivity || false
});
